// extracted by mini-css-extract-plugin
export default {"page":"maintenance_page__+txzw","gif":"maintenance_gif__mef65"};